import { call, takeLatest } from 'redux-saga/effects';
import api from '@control-front-end/common/sagas/api';
import {
  GET_FORM_ACCOUNTS,
  MANAGE_FORM_ACCOUNTS,
} from '@control-front-end/common/constants/forms';
import { createAccountCurrencies } from '@control-front-end/common/sagas/accountCurrencies';
import { createAccountName } from '@control-front-end/common/sagas/accountNames';
import { RequestStatus } from '@control-front-end/common/constants/index';

/**
 * Получить список счетов шаблона
 */
function* getFormAccounts({ payload, callback }) {
  const { formId } = payload;
  const { result, data } = yield call(api, {
    method: 'get',
    url: `/form_accounts/${formId}`,
  });
  if (result !== RequestStatus.SUCCESS) return;
  if (callback) callback(data.data);
}

/**
 * Создать по умолчанию для шаблона
 */
function* createFormAccount(formId, accData) {
  const {
    accountType = 'fact',
    currencyId,
    nameId,
    treeCalculation,
    search,
    minLimit,
    maxLimit,
  } = accData;
  yield call(api, {
    method: 'post',
    url: `/form_accounts/${formId}`,
    body: {
      accountType,
      currencyId,
      nameId,
      treeCalculation,
      search,
      minLimit,
      maxLimit,
    },
  });
}

/**
 * Удалить счет по умолчанию для шаблона
 */
function* removeFormAccount(id) {
  yield call(api, {
    method: 'delete',
    url: `/form_accounts/${id}`,
  });
}

/**
 * Редактировать счета по умолчанию для шаблона
 */
export function* manageFormAccounts({ payload }) {
  const { formId, formAccounts: formAccountsActions } = payload;
  // создать новые валюты и наименования счетов
  for (const item of formAccountsActions) {
    const { curAction, currencyName, nameAction, accName } = item.data;
    if (curAction === 'create') {
      const { id: newCurrencyId } = yield call(createAccountCurrencies, {
        payload: currencyName,
      });
      formAccountsActions
        .filter(
          ({ data }) =>
            data.currencyName &&
            data.currencyName.trim() === currencyName.trim()
        )
        .forEach(({ data }) => {
          data.currencyId = newCurrencyId;
          delete data.curAction;
        });
    }
    if (nameAction === 'create') {
      const { id: newNameId } = yield call(createAccountName, {
        payload: accName,
      });
      formAccountsActions
        .filter(
          ({ data }) => data.accName && data.accName.trim() === accName.trim()
        )
        .forEach(({ data }) => {
          data.nameId = newNameId;
          delete data.nameAction;
        });
    }
  }
  // создать/удалить счета
  for (const acc of formAccountsActions) {
    if (acc.action === 'create') {
      yield call(createFormAccount, formId, acc.data);
    } else {
      yield call(removeFormAccount, acc.data.id);
    }
  }
}

function* formAccounts() {
  yield takeLatest(GET_FORM_ACCOUNTS.REQUEST, getFormAccounts);
  yield takeLatest(MANAGE_FORM_ACCOUNTS.REQUEST, manageFormAccounts);
}

export default formAccounts;
